export default __webpack_public_path__ + "static/media/overlay-bleck.39d46073.png";